var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonStarsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1954px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1953",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil1 {fill:#996A0B}\n    .fil0 {fill:white}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,9 372,9 372,1944 192,1767 9,1944 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "284,122 248,163 198,141 225,188 189,229 242,217 270,265 275,210 329,199 279,177 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "284,411 248,452 198,430 225,477 189,518 242,506 270,553 275,499 329,487 279,465 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "284,699 248,740 198,718 225,766 189,806 242,795 270,842 275,788 329,776 279,754 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "284,988 248,1029 198,1007 225,1054 189,1095 242,1083 270,1131 275,1076 329,1065 279,1043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "284,1277 248,1318 198,1296 225,1343 189,1384 242,1372 270,1420 275,1365 329,1353 279,1331 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "284,1566 248,1607 198,1584 225,1632 189,1673 242,1661 270,1708 275,1654 329,1642 279,1620 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "142,256 105,297 55,275 83,322 46,363 100,352 127,399 133,344 186,333 136,311 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "142,545 105,586 55,564 83,611 46,652 100,640 127,688 133,633 186,622 136,600 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "142,834 105,875 55,852 83,900 46,941 100,929 127,976 133,922 186,910 136,888 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "142,1122 105,1163 55,1141 83,1189 46,1229 100,1218 127,1265 133,1210 186,1199 136,1177 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "142,1411 105,1452 55,1430 83,1477 46,1518 100,1506 127,1554 133,1499 186,1488 136,1466 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonStarsWhite);
export default __webpack_public_path__ + "static/media/ribbon-stars-white.62d6df2aa5443baeb3ab1ec8bd769615.svg";
export { ForwardRef as ReactComponent };